type LoginOption {
  client_id: ID!
  first_name: String
  last_name: String
  organisation_name: String
}

type AuthMagicLink {
  hasError: Boolean
  loginOptions: [LoginOption!]
}
